module.exports = __webpack_public_path__ + "img/arthur.8acd7b6f.png";